import { useOrdersContext } from '@/contexts/OrderContext';
import useDeliveryFees from '@/hooks/useDeliveryFees';

const MinimumPrice = () => {
    const { cart, handleGetTotalPrice } = useOrdersContext();
    const { handleCalculateDeliveryFee } = useDeliveryFees();

    return (
        <>
            {(cart.is_no_limit && cart.is_no_limit_minimum_amount > 0) && <h3 className='text-sm'>Minimum de commande: {cart.is_no_limit_minimum_amount}€ {(handleGetTotalPrice().total + handleCalculateDeliveryFee()) < cart.is_no_limit_minimum_amount && <small className='text-primary font-bold'>(encore {cart.is_no_limit_minimum_amount - (handleGetTotalPrice().total + handleCalculateDeliveryFee())}€)</small>}</h3>}
        </>
    );
}

export default MinimumPrice;